<template>
  <div class="support-search-results">
    <h2>Searching for '{{ decodeURI(queryString) }}'</h2>
    <p
      class="support-search-results__sub-header"
      v-if="results.length > 0 && !fetchingData"
    >
      About {{ searchInfo.formattedTotalResults }} results ({{
        searchInfo.formattedSearchTime
      }}
      seconds)
    </p>
    <hr />
    <div v-if="results.length === 0 && !fetchingData">
      <p class="support-search-results__no-results">No results found</p>
    </div>
    <div v-else>
      <ul class="support-search-results__result-list">
        <li v-for="(item, index) in results" :key="index">
          <a target="_blank" :href="item.link" v-html="item.htmlTitle"></a>
          <p v-html="item.htmlFormattedUrl"></p>
          <p>{{ item.snippet }}</p>
        </li>
      </ul>
      <hr />
      <div class="support-search-results__pagination">
        <ul>
          <li
            v-for="control in paginationControls"
            :class="{ active: control.index === currentPage }"
            @click="getResults(control.index)"
            :key="control.index"
          >
            {{ control.index }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import parseParameters from '../../twig/helpers/parse-parameters';

export default {
  methods: {
    getResults(index) {
      const params = parseParameters(window.location.search);
      const start = index * 10 - 9;

      this.currentPage = index;
      this.queryString = params.searchString || '';

      $.get(
        `https://www.googleapis.com/customsearch/v1?key=${this.googleAPIKey}&cx=${this.searchEngineId}&q=${this.queryString}&start=${start}`
      ).then((data) => {
        this.results = data.items ? data.items : [];
        this.searchInfo = data.searchInformation;
        this.setUpPagination();
        this.fetchingData = false;

        window.scrollTo(0, 0);
      });
    },

    setUpPagination() {
      this.paginationControls = [];
      this.numberOfPages =
        Math.floor(parseInt(this.searchInfo.totalResults, 10) / 10) + 1;
      this.numberOfPages = this.numberOfPages > 10 ? 10 : this.numberOfPages;

      for (let i = 0; i < this.numberOfPages; i++) {
        this.paginationControls.push({
          index: i + 1,
          start: (i + 1) * 10 - 9
        });
      }
    }
  },
  data() {
    return {
      results: [],
      searchInfo: {},
      queryString: '',
      numberOfPages: 0,
      paginationControls: [],
      fetchingData: true,
      currentPage: 1,
      googleAPIKey: 'AIzaSyBkBqK8YMfqCTu8WLmNqA7RQ-l_ihZnkRs',
      searchEngineId: 'f4108dd154f8c4d82'
    };
  },
  mounted() {
    this.getResults(1);
  }
};
</script>
